// import 'lazysizes'
import hamburger from './components/hamburger'
// import submenu from './components/submenu'

hamburger() // Hamburger menu
// submenu() // Mobile submenu accordions